// ---------------------------------------------------------------
// Copyright (c) Aspen Publishing. All rights reserved.
// ---------------------------------------------------------------

const cartItem = class extends HTMLElement {
  constructor() {
    super();

    this.checkbookGift = Array.from(this.querySelectorAll('.offer-purchase-checkbox[type="checkbox"]'));

    if (this.checkbookGift.length > 0) {
      this.checkbookGift.forEach(checkbox => {
        checkbox.addEventListener('change', this.addOrRemoveGift.bind(this));
      });
    }

    this.sectionName = 'cart-section';

    this.sections = [
      {
        key: 'count',
        section: 'cart-live-region-text',
      },
      {
        key: 'noti-success',
        section: 'popup-noti-added',
      },
      {
        key: 'noti',
        section: 'cart-noti',
      },
      {
        key: 'section',
        section: this.sectionName,
      },
    ];
  }

  reloadCart() {
    const cartComponent = document.querySelector('cart-component');

    if (cartComponent) {
      cartComponent.refreshCart('main-cart-page');
    }
  }

  showLoad() {
    const body = document.querySelector('body');

    if (body) {
      body.classList.add('no-scroll');
    }

    const load = document.querySelector('.loader');

    if (load) {
      load.classList.add('active');
    }
  }

  async addOrRemoveGift(event) {
    try {
      const checked = event.target.checked;
      const id = event.target.value;

      if (!id) {
        throw new Error('ID not found');
      }

      const currentCart = await fetch('/cart.js').then(response => response.json());

      if (!currentCart || !currentCart.items) {
        throw new Error('Cart not found');
      }

      let currentItem = currentCart.items.find(item => item.key === id);

      if (!currentItem) {
        currentItem = currentCart.items.find(item => item.id === parseInt(id.split(':')[0]));

        if (!currentItem) {
          throw new Error('Item not found');
        }
      }

      const updates = {
        id: currentItem.key,
        quantity: currentItem.quantity,
        properties: currentItem.properties || {},
      };

      if (checked) {
        updates.properties['_gift'] = true;
      } else {
        delete updates.properties['_gift'];
      }

      const resCart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates),
      });

      if (!resCart.ok) {
        throw new Error('Error in response from /cart/change.js');
      }

      this.reloadCart();
    } catch (error) {
      console.error('Error in addOrRemoveGift:', error);
      this.disableLoad();
    }
  }

  disableLoad() {
    const body = document.querySelector('body');

    if (body) {
      body.classList.remove('no-scroll');
    }

    const load = document.querySelector('.loader');

    if (load) {
      load.classList.remove('active');
    }
  }
};

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', cartItem);
}

const CartEditScoreReportButton = class extends HTMLElement {
  constructor() {
    super();

    this.cartItemDataScript = this.querySelector('.cart-item-data');
  }

  connectedCallback() {
    this.cartItemData = this.cartItemDataScript.textContent ? JSON.parse(this.cartItemDataScript.textContent) : {};

    this.addEventListener('click', this.openScoreReportPopup.bind(this));
    this.addEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.openScoreReportPopup();
    }
  }

  /**
   * Open the score report popup for editing with saved data
   */
  async openScoreReportPopup() {
    const popupTrigger = document.querySelector('[data-popup="popup-score-report"]');

    if (popupTrigger) {
      popupTrigger.click();

      setTimeout(() => {
        this.populateScoreReportForm();
      }, 500);

      return;
    }

    this.loadScoreReportPopup();
  }

  async loadScoreReportPopup() {
    try {
      const popupUrl = `/products/${this.cartItemData.handle}/?variant=${this.cartItemData.variant_id}&section_id=popup-score-report`;

      document.body.classList.add('event-none');

      const response = await fetch(popupUrl);
      const html = await response.text();
      const parts = html.split('<!-- split -->');

      if (parts.length > 1) {
        const popupContent = parts[1];
        document.body.insertAdjacentHTML('beforeend', popupContent);

        setTimeout(() => {
          this.populateScoreReportForm();
        }, 500);
      }
    } finally {
      document.body.classList.remove('event-none');
    }
  }

  /**
   * Populate the score report form with saved data for editing
   */
  populateScoreReportForm() {
    const scoreReportComponent = document.querySelector('score-report');

    if (!scoreReportComponent || typeof scoreReportComponent.populateFromSavedData !== 'function') {
      return;
    }

    // Set this cart item button as the trigger element for proper focus management
    scoreReportComponent.triggerElement = this;

    scoreReportComponent.addEventListener('score-report:initialized', () => {
      scoreReportComponent.populateFromSavedData(this.cartItemData);
    });
  }
};

if (!customElements.get('cart-edit-score-report')) {
  customElements.define('cart-edit-score-report', CartEditScoreReportButton);
}
